module.exports = __webpack_public_path__ + "img/Img26_197253_CeEt-7-6B4-1412.4973f833.jpg";